import React from "react";
import { Button, Grid, Modal as MuiModal, Typography } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers/icons";

interface Props {
  showConfirmResetModal: boolean;
  closeShowConfirmResetModal: () => void;
  resetPrivileges: () => void;
}

const ResetPrivileges: React.FC<Props> = ({
  showConfirmResetModal,
  closeShowConfirmResetModal,
  resetPrivileges,
}) => {
  return (
    <MuiModal open={showConfirmResetModal} className="modal-primary">
      <div className="paper" style={{ width: 430 }}>
        <div className="paperInner">
          <Grid container>
            <Grid item xs={12}>
              <div className="main-header" style={{ marginBottom: "20px" }}>
                <span>Reset to Default?</span>
                <span id="dismiss-button" onClick={closeShowConfirmResetModal}>
                  <ClearIcon sx={{ width: 30, height: 30 }} />
                </span>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{
                paddingLeft: "24px",
                paddingRight: "24px",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 500,
                  lineHeight: "22px",
                  color: "#1E1E1E",
                }}
              >
                You are attempting to reset this user’s privileges. Are you sure
                you want to continue?
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="modal-footer"
          >
            <Grid item xs={12} className="confirm-btn-container">
              <div onClick={closeShowConfirmResetModal} className="cancel-link">
                Cancel
              </div>
              <Button
                onClick={resetPrivileges}
                className="confirm-btn"
                style={{ width: 156 }}
              >
                Confirm
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </MuiModal>
  );
};

export default ResetPrivileges;
